/*
 Provides Props:
 ------------------------------------
 state.zoom // Object
 * level  // Number - zoom factor (i.e. 2 === 200%/2x zoom in)
 * max    // Number - current max zoom-level/factor -
 // this depends on both forecastData.maxZoom(??)
 // and state.format (widget width/size)
 * x, y   // Number (0...1) zoom/pan centerpoint offset

 * size:       // Number (%) Current zoom-factor (i.e. zoom.level*100
 * left, top:  // Number (%) Current view-box edge offset

 Actions:
 --------
 state.setZoom( level, centerX, centerY )
 // Updates zoom to new level and center-pos
 // Performs boundry-checks, etc.

 state.toggleZoomIn( centerX, centerY )
 // Toggle zomm.level between 1 and zoom.max
 // towards (or away from) an (optional) new centerpoint

 state.zoomIn( centerX, centerY )
 state.zoomOut( centerX, centerY )
 // Increase/decrease zoom level by one standard step
 // towards (or away from) an (optional) new centerpoint

 state.panZoomBy( deltaX, deltaY )
 // Shift zoom.x and zoom.y without changing zoom.level

 state.resetZoom()
 // Resets zoomlevel to 1 center-align the panning


 Responds to:
 --------
 'forecast-switch' - resets the zoom.level
 'format' - re-calculates zoom.max


 Emits:
 --------
 'zoom' -  when any zoom properties change

 */
import {updateObject} from "../../_js/utils";

export default function (state, widget) {

    const _calcMaxZoom = function (format) {
        const newMax = widget.maxZoom[format.is];
        if (newMax !== state.zoom.max) {
            state.zoom = updateObject(state.zoom, {max: newMax});
            state.setZoom();
        }
    };

    // ------------------------------------------------

    state.zoom = {
        level: 1,
        max: 1,
        x: 0.5,
        y: 0.5,

        size: 100,
        left: 0,
        top: 0,
    };

    // ------------------------------------------------

    state.setZoom = function (level, centerX, centerY) {
        const zoom = state.zoom;
        const maxLevel = zoom.max;
        centerX = centerX != null ? centerX : zoom.x;
        centerY = centerY != null ? centerY : zoom.y;
        level = level || zoom.level;
        level = level < 1 ? 1 : level > maxLevel ? maxLevel : level;

        if (level !== zoom.level || centerX !== zoom.x || centerY !== zoom.y) {
            const halfSize = 0.5 / level;
            centerX = centerX < halfSize ? halfSize : (centerX + halfSize) > 1 ? 1 - halfSize : centerX;
            centerY = centerY < halfSize ? halfSize : (centerY + halfSize) > 1 ? 1 - halfSize : centerY;
            const size = 100 * level;

            state.zoom = {
                level: level,
                max: maxLevel,
                x: centerX,
                y: centerY,
                size: size,
                left: size * (centerX - halfSize),
                top: size * (centerY - halfSize),
            };
            state.emit('zoom');
        }
    };

    state.toggleZoomIn = function (centerX, centerY) {
        // If we're zoomed in, we "toggle" to zooming all the way out.
        // If we're at full map, we go to maxZoom but not more than 3x to avoid being too jarring.
        const newLevel = state.zoom.level === 1 ? Math.min(state.zoom.max, 3) : 1;
        state.setZoom(newLevel, centerX, centerY);
    };
    state.zoomIn = function (centerX, centerY) {
        const newLevel = 1.5 * state.zoom.level;
        state.setZoom(newLevel, centerX, centerY);
    };
    state.zoomOut = function (centerX, centerY) {
        const newLevel = state.zoom.level / 1.5;
        state.setZoom(newLevel, centerX, centerY);
    };
    state.panZoomBy = function (deltaX, deltaY) {
        const zoom = state.zoom;
        state.setZoom(
            zoom.level,
            zoom.x + deltaX,
            zoom.y + deltaY
        );
    };

    state.resetZoom = function () {
        state.setZoom(1);
    };


    // ------------------------------------------------

    state.on('forecast-switch', state.resetZoom);
    state.on('format', _calcMaxZoom);


}
